import React from 'react';

import GuestAccessSrc from './assets/GuestAccess.png';

export const GuestAccess = () => {
	return <img alt="Guest access screen in Confluence" src={GuestAccessSrc} width="70%" />;
};
